"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {
      display: 'inline-block',
      cursor: 'pointer',
      lineHeight: 0
    },
    input: {
      display: 'none'
    },
    disabled: {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  };
};

exports.default = _default;